import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export type EditorContentLinkType = 'document' | 'post' | 'event' | 'group';

export interface EditorContentLinkTarget {
  type: EditorContentLinkType;
  title: string;
  url: string;
  subtitle?: string;
}

/**
 * App-provided search backing the editor's inline "#" content-link trigger.
 * Returns linkable content (documents, posts, events, groups) matching the
 * query, each with the stable app URL to insert. When absent, the trigger
 * stays inactive.
 */
export const EDITOR_CONTENT_LINK_SEARCH = new InjectionToken<
  (query: string) => Observable<EditorContentLinkTarget[]>
>('EDITOR_CONTENT_LINK_SEARCH');
